import { Controller } from "@hotwired/stimulus"

// Client-side failures use the exact same FlashComponent markup as redirects and Turbo
// streams. The template is inert until cloned; once appended, Stimulus connects the normal
// toast controller that owns dismissal and the close button.
export default class extends Controller {
  static targets = ["template"]

  show(event) {
    const message = event.detail?.message
    if (!message) return

    const toast = this.templateTarget.content.firstElementChild.cloneNode(true)
    toast.querySelector("[data-flash-message]").textContent = message
    this.element.append(toast)
  }
}
